var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtLaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54697 14.3155C2.16456 11.826 1.97281 10.5823 2.44406 9.47841C2.91422 8.37557 3.95856 7.62049 6.04614 6.11141L7.60614 4.98366C10.2029 3.10624 11.5018 2.16699 13.0001 2.16699C14.4983 2.16699 15.7972 3.10624 18.394 4.98366L19.954 6.11141C22.0416 7.62049 23.0848 8.37557 23.5561 9.47841C24.0262 10.5823 23.8356 11.826 23.4531 14.3144L23.1271 16.4377C22.5854 19.9651 22.3135 21.7287 21.0481 22.7817C19.7828 23.8347 17.9336 23.8337 14.234 23.8337H11.7651C8.06547 23.8337 6.21622 23.8337 4.95089 22.7817C3.68556 21.7287 3.41472 19.9651 2.87197 16.4367L2.54697 14.3155Z",
    stroke: "#5A5A5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 14.3545C13.4734 15.6404 15.1667 16.9469 15.1667 16.9469L17.4882 14.6253C17.4882 14.6253 16.1818 12.9321 14.8958 11.6462C13.6099 10.3602 11.9167 9.05374 11.9167 9.05374L9.59508 11.3753C9.59508 11.3753 10.9016 13.0686 12.1875 14.3545ZM12.1875 14.3545L8.125 18.417M17.875 14.2386L14.7799 17.3337M12.3034 8.66699L9.20833 11.7621",
    stroke: "#5A5A5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtLaw);
export default __webpack_public_path__ + "static/media/court-law.06f06a91ebf98c62df9da31277bd6908.svg";
export { ForwardRef as ReactComponent };